import React, { useContext } from 'react';
import classnames from 'classnames';
import License from '../../../License';
import JournalTags from '../_partials/JournalTags';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import DeviationAttributeCSV from '../_partials/DeviationAttributeCSV';
import TextualContent from '../../TextualContent';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import s from './Journal.scss';
const Journal = ({ deviation , deviation: { deviationId , author , publishedTime , textContent , extended: { license , tags , journalSkinFullwidth  } = {}  } , className , contentClassName  })=>{
    const isMobile = useContext(MobileContext);
    const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    const isLegacy = (textContent === null || textContent === void 0 ? void 0 : textContent.html.type) === 'writer';
    const isLegacyView = isLegacy && !journalSkinFullwidth;
    const isFullWidthView = isLegacy && journalSkinFullwidth;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isLegacyView && s['is-legacy-journal'], isFullWidthView && s['is-fullwidth-skin'], className, contentClassName)
    }, isMobile && /*#__PURE__*/ React.createElement(TextualContent, {
        deviation: deviation,
        withArtist: false
    }), isExtendedLoaded && /*#__PURE__*/ React.createElement(React.Fragment, null, tags && /*#__PURE__*/ React.createElement(JournalTags, {
        key: `detailsTags-${deviationId}`,
        tags: tags
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['misc']
    }, /*#__PURE__*/ React.createElement(DeviationAttributeCSV, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['license']
    }, /*#__PURE__*/ React.createElement(License, {
        license: license,
        author: author,
        publishedTime: publishedTime,
        showSymbol: false
    })))));
};
Journal.displayName = 'Journal';
export default Journal;
